import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
// import {Harbor} from '../../harbors/models/harbor.model';
// import {PricesService} from '../../prices/prices.service';
import {CarsService} from '../cars.service';
import {GooglePlaceDirective} from 'ngx-google-places-autocomplete';
// import {Observable} from 'rxjs/Observable';
// import {AppState} from '../../../reducers';
// import {currenciesFeatureKey} from '../../../currency/currency.reducer';
// import {map} from 'rxjs/operators/map';
// import {getCurrencies} from '../../../currency/currency.actions';
// import {Currency} from '../../../currency/currency.model';
import {NbDialogConfig, NbDialogRef, NbDialogService} from '@nebular/theme';
// import {FileUploadComponent} from '../file-upload/file-upload.component';
// import {CarPhotoModel} from '../models/car-photo.model';
import {faCartPlus, faGlobe, faLock, faFileInvoice} from '@fortawesome/free-solid-svg-icons';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {ImageDialogComponent} from '../image-dialog/image-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ThankYouGaDialogComponent} from './thank-you-ga-dialog.component';
import {MessageService} from 'primeng/api';
import {map} from 'rxjs/operators';
import * as moment from 'moment';
import {round} from 'lodash';
import {MyCarModalComponent} from '../../cars/my-list/my-car-modal/my-car-modal.component';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import { State } from '../../auth/login/reducers/login.reducer';
import { selectLoginState } from '../../auth/login/selectors/login.selectors';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {UserInfoGaModalComponent} from '../user-info-ga/user-info-ga-modal.component';
import {calcCarClearance, Fuel, getManufactureYearFromDates, Input as CarClearanceInput} from '../rs-car-clearance';

declare let dataLayer: Array<any>;

@Component({
  selector: 'app-car-modal-ga',
  templateUrl: './car-modal-ga.component.html',
  styleUrls: ['./car-modal-ga.component.scss'],
  providers: [MessageService]
})
export class CarModalGaComponent implements OnInit, OnDestroy {
  isLoading = true;
  faCartPlus: any = faCartPlus;
  faInvoice = faFileInvoice;
  isLogin = false;
  isCarMarket = false;
  tab = 0;

  @Input() isLoadingCalc: BehaviorSubject<boolean>;
  isLoadingCalcSubscription: Subscription;
  loaded = false;

  @Input() vehicleValue: BehaviorSubject<number>;
  vehicleValueSubscription: Subscription;
  calculatedPrice: number;

  data: any;
  coll: any;
  source: 'commercial' | 'personal';
  importType = 'Commercial';
  currencies: any;
  mode: string;
  countries: any[];
  exwCountries: any[] = [];
  fcaCountries: any[] = [];
  countriesOnDisplay: any[] = [];
  fcaCountriesOnDisplay: any[] = [];
  price: any;
  carForm: FormGroup;
  harbors: any[] = [];
  photos: any[] = [];
  // countries: any[];
  // @ViewChild(FileUploadComponent, {static: false}) fileUploadComponent: FileUploadComponent;
  // @ViewChild('fileUploadComponent') fileUploadComponent: FileUploadComponent;
  dialogRef: NbDialogRef<CarModalGaComponent>;


  shipmentMethods: any[] = [];
  currencies$: Observable<any[]>;

  doorNumbers: number[] = Array.from({length: 6}, (_, i) => i + 1);
  seatNumbers: number[] = Array.from({length: 11}, (_, i) => i + 1);
  // userFile: FileUpload | null = null;
  // additionalFiles: FileUpload[] = [];
  // files: CarPhotoModel[] = [];

  faGlobe: any = faGlobe;
  // exw
  exwRates: any[] = [];
  exwSelectedCountry: any = '';
  exwSelectedCity: any = '';
  exwConfig = {countries: [], cities: [], harbors: []};
  exwCities: any[] = [];
  exwSelectFromGoogleCity = false;
  fcaSelectFromGoogleCity = false;
  fcaSelectedCountry: any = '';
  fcaSelectedHarbor: any = '';
  fcaHarbors: any[] = [];

  selectedCurrency: any;
  selectedCfrCurrency: any;

  showGel = true;
  loginStatus$: Observable<State>;

  placesOptions = {
    types: ['(cities)'],
    // componentRestrictions: {country: 'IL'}
  };
  @ViewChild('placesRef') placesRef: GooglePlaceDirective;
  isMobile: boolean;

  /**
   * Configuration constants for pricing.
   * For a production app, consider moving these to a configuration service or environment file.
   */
    // Example: 1 USD = 2.7 GEL (update periodically).
  private readonly GEL_TO_USD_RATE = 2.7;
  // A placeholder for other costs (e.g., shipping, insurance, US-side fees) in USD.
  private readonly SHIPPING_AND_OTHER_FEES_USD = 0;


  castUSDToDirham(usd: number): number {
    const conversionRate = 3.67; // Example conversion rate, please use the current rate
    return usd * conversionRate;
  }

  // Method to convert EUR to Dirham
  castEURToDirham(eur: number): number {
    const conversionRate = 4.05; // Example conversion rate, please use the current rate
    return eur * conversionRate;
  }

  /**
   * A helper function to map the `car.FuelType` string to the `Fuel` enum required by the calculator.
   */
  private mapCarFuelTypeToEnum(fuelType: string): Fuel {
    const lowerFuel = (fuelType || '').toLowerCase();
    if (lowerFuel.includes('hybrid')) return 'hybrid';
    if (lowerFuel.includes('electric')) return 'electric';
    if (lowerFuel.includes('diesel')) return 'diesel';
    return 'petrol'; // default to petrol/benzin
  }

  public getCarPrice(car: any): number {
    // --- Step 0: Validate input ---
    // debugger;
    if (!car || typeof car.CarPrice !== 'number') {
      console.error("getCarPrice: Invalid or incomplete car object provided.", car);
      return 0;
    }
    // Resolve manufacture year: prefer FirstUseDate, then ManufactureDate, else fallback to numeric ProductionYear
    const resolvedYear = getManufactureYearFromDates(car) ?? Number(car.ProductionYear);
    if (!resolvedYear || isNaN(resolvedYear) || resolvedYear < 1900) {
      console.error("getCarPrice: Unable to resolve a valid manufacture year from FirstUseDate/ManufactureDate/ProductionYear.", { FirstUseDate: car.FirstUseDate, ManufactureDate: car.ManufactureDate, ProductionYear: car.ProductionYear });
      return 0;
    }

    // Resolve engine liters with default fallback (1.5L) when missing/invalid
    const engineLiters =
      typeof car.EngineSize === 'number' && car.DisplacementLiters > 0 ? car.DisplacementLiters : 1.5;
    if (engineLiters === 1.5) {
      console.warn('getCarPrice: EngineSize missing/invalid; defaulting to 1.5L.');
    }

    // --- Step 1: Prepare customs clearance input ---
    const clearanceInput: CarClearanceInput = {
      manufactureYear: resolvedYear,
      engineLiters,
      fuel: this.mapCarFuelTypeToEnum(car.FuelType),
      rightWheelMoved: car.Steering?.toLowerCase() === 'right',
    };

    // --- Step 2: Calculate customs duties in GEL ---
    const clearanceBreakdown = calcCarClearance(clearanceInput, car);
    const clearanceCostGEL = clearanceBreakdown.totalGEL;

    // --- Step 3: Convert customs cost to USD (for consistency in landed cost calc) ---
    const clearanceCostUSD = clearanceCostGEL / this.GEL_TO_USD_RATE;

    // --- Step 4: Total landed cost in USD ---
    const totalLandedCostUSD =
      car.CarPrice + this.SHIPPING_AND_OTHER_FEES_USD + clearanceCostUSD;

    // --- Step 5: Always return in GEL ---
    return Math.round(totalLandedCostUSD * this.GEL_TO_USD_RATE);
  }

  onRateChange($event: any): void {
    console.log($event);
    this.carForm.get('RateType')?.patchValue($event);


    // clear all values
    this.carForm.get('ExwCity')?.patchValue(null);
    this.carForm.get('ExwRateId')?.patchValue(null);
    this.carForm.get('Country')?.patchValue(null);
    this.carForm.get('FcaRateId')?.patchValue(null);
    this.carForm.get('FcaDischargeHarbor')?.patchValue(null);
    this.carForm.get('FcaHarbor')?.patchValue(null);
    this.carForm.get('CfrType')?.patchValue(null);
    this.carForm.get('CfrPrice')?.patchValue(null);
    this.carForm.get('CfrCurrencyType')?.patchValue(null);
    this.carForm.get('CfrImportType')?.patchValue(null);
    this.fcaSelectedCountry = '';
    this.exwSelectedCountry = '';
    if ($event === 'FCA') {

      this.fcaCountriesOnDisplay = this.fcaCountries;

    } else if ($event === 'EXW') {
      this.countriesOnDisplay = this.exwCountries;
    }
  }

  onLocationToggleChange(checked: boolean): void {
    if (checked) {
      this.carForm.get('Location').setValue('Israel');
    } else {
      this.carForm.get('Location').setValue('');
    }
  }

  onCertToggleChange(checked: boolean): void {
    if (checked) {
      this.carForm.get('CertificateOfOrigin').setValue('Yes');
    } else {
      this.carForm.get('CertificateOfOrigin').setValue('No');
    }
  }




  constructor(private _fb: FormBuilder,
              private messageService: MessageService,
              // private pricesService: PricesService,
              private carService: CarsService,
              // private store: Store<AppState>,
              private store: Store<AppState>,
              public nbDialogRef: NbDialogRef<CarModalGaComponent>,
              public dialog: MatDialog,
              public dialogService: NbDialogService,
              private breakpointObserver: BreakpointObserver,
  ) {
    this.loginStatus$ = this.store.select(selectLoginState).pipe(map(loginState => {
      console.log('loginStatus', loginState);

      return loginState;
    }));

    this.loginStatus$.subscribe((state) => {
      console.log('loginStatus sub', state);
      this.isLogin = state.isLogin;
    });

  }

  openDialog(index: number): void {
    this.dialog.open(ImageDialogComponent, {
      data: {
        images: this.data.Files,
        currentIndex: index
      },
      panelClass: 'bounce-dialog'
    });
  }

  closeDialog(): void {
    this.nbDialogRef.close();
  }

  _toggleInterest() {

    dataLayer.push({
      event: 'button_click_interested',
      item_id: this.data.id,
      item_name: this.data.Manufacturer + ' ' + this.data.Model,
      item_price: this.data.CarPrice,
      item_year: this.data.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });

    const dialogConfig = {
      hasBackdrop: true,
      closeOnEsc: true,
      backdropClass: '',
      closeOnBackdropClick: false,
      hasScroll: false,
      autoFocus: false,
      viewContainerRef: undefined,
    };
    this.carService.updateUAEInterest(this.data.id, 'Interested', this.importType).subscribe((res: any) => {
      console.log(res);
    });
    const thankYouDlg = this.dialogService.open(ThankYouGaDialogComponent, dialogConfig);

    thankYouDlg.onClose.subscribe((result: any) => {
      this.nbDialogRef.close(this.data);
    });
  }

  async ngOnInit(): Promise<any> {
    // this.showGel = sessionStorage.getItem('user-id') === '530';

    this.exwRates = this.exwCountries;
    this.carForm = this.createCarForm();
    this.exwSelectedCountry = this.data?.Rate?.country ?? '';
    this.fcaSelectedCountry = this.data?.Rate?.country ?? '';
    this.countriesOnDisplay = this.exwCountries;
    this.fcaCountriesOnDisplay = this.fcaCountries;
    this.selectedCurrency = this.data?.CurrencyType ?? '';
    this.selectedCfrCurrency = this.data?.Rate?.cfrCurrencyType ?? '';

    // this.calculatedPrice = this.data?.C_Price ?? 0;

    this.isLoading = false;
    this.loaded = true;
    // this.vehicleValueSubscription = this.vehicleValue.subscribe((value: any) => {
    //   // Do something with the value
    //   if (value) {
    //     console.log(value);
    //     this.calculatedPrice = value.value;
    //   }
    // });
    //
    // this.isLoadingCalcSubscription = this.isLoadingCalc.subscribe(loading => {
    //   // Do something with the value
    //   this.loaded = !loading;
    //   if (!loading) {
    //     console.log('modal ready to calc');
    //   }
    // });

    this.isMobileView();
  }

  ngOnDestroy() {
    // this.vehicleValueSubscription.unsubscribe();
    // this.isLoadingCalcSubscription.unsubscribe();
  }

  createCarForm() {
    const id = this.data ? this.data.id || '' : '';
    const filesArray = this.data && this.data.Files ? this._fb.array(this.data.Files) : this._fb.array([]);
    const mainFile = this.data && this.data.Files && this.data.Files.length > 0
      ? this.data.Files.find((file: any) => file.isMain)?.title || ''
      : '';


    return this._fb.group({
      id: [id],
      Manufacturer: [this.data?.Manufacturer ?? '', Validators.required],
      Model: [this.data?.Model ?? '', Validators.required],
      FinishLevel: [this.data?.FinishLevel ?? ''],
      TotalWeight: [this.data?.TotalWeight ?? ''],
      ManufactureDate: [this.formatDate(this.data?.ManufactureDate ?? '')],
      CarStatus: [this.data?.CarStatus ?? ''],
      FirstUseDate: [this.formatDate(this.data?.FirstUseDate ?? '')],
      Mileage: [this.data?.Mileage ?? ''],
      SaleCondition: [this.data?.SaleCondition ?? ''],
      Port: [this.data?.Port ?? ''],
      OverlandDeliveryPrice: [this.data?.OverlandDeliveryPrice ?? ''],
      PickupLocation: [this.data?.PickupLocation ?? ''],
      CertificateOfOrigin: [this.data?.CertificateOfOrigin ?? 'No'],
      Location: [this.data?.Location ?? ''],
      ExteriorColor: [this.data?.ExteriorColor ?? ''],
      UpholsteryColor: [this.data?.UpholsteryColor ?? ''],
      FuelType: [this.data?.FuelType ?? ''],
      NumberOfDoors: [this.data?.NumberOfDoors ? parseInt(this.data.NumberOfDoors, 0) : null],
      NumberOfSeats: [this.data?.NumberOfSeats ? parseInt(this.data.NumberOfSeats, 0) : null],
      CarPrice: [this.data?.CarPrice ?? '', Validators.required],
      CurrencyType: [this.data?.CurrencyType ?? '', Validators.required],
      Notes: [this.data?.Notes ?? ''],
      MainFile: [mainFile],
      Status: [this.data?.Status ?? ''],
      Files: filesArray,
      PollutionRank: [this.data?.PollutionRank ?? '4'],
      EquipLevel: [this.data?.EquipLevel ?? '4'],

      // rate data
      RateId: [this.data?.id ?? ''],
      RateType: [this.data?.Rate?.type ?? ''],
      Country: [this.data?.Rate?.country ?? ''],
      ExwCity: [this.data?.Rate?.exwCity ?? ''],
      ExwRateId: [this.data?.Rate?.exwRateId ?? ''],
      FcaRateId: [this.data?.Rate?.fcaRateId ?? ''],
      FcaHarbor: [this.data?.Rate?.fcaHarbor ?? ''],
      FcaDischargeHarbor: [this.data?.Rate?.fcaDischargeHarbor ?? ''],
      CfrImportType: [this.data?.Rate?.cfrImportType ?? ''],
      CfrPrice: [this.data?.Rate?.cfrPrice ?? ''],
      CfrCurrencyType: [this.data?.Rate?.cfrCurrencyType ?? ''],
    });

  }

  get f() {
    return this.carForm.controls;
  }

  saveCar(status: string) {

  }


  cancelCar(src: string = '') {
    dataLayer.push({
      event: 'button_click_Close_' + src,
      item_id: this.data.id,
      item_name: this.data.Manufacturer + ' ' + this.data.Model,
      item_price: this.data.CarPrice,
      item_year: this.data.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });

    this.nbDialogRef.close(this.data);
  }

  createInvoice(in0: any) {
    dataLayer.push({
      event: 'button_click_create_invoice',
      item_id: this.data.id,
      item_name: this.data.Manufacturer + ' ' + this.data.Model,
      item_price: this.data.CarPrice,
      item_year: this.data.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });


    this.toggleMoreInfo(this.data);
  }

  isMobileView(): boolean {
    this.isMobile = this.breakpointObserver.isMatched(Breakpoints.Handset);
    return this.breakpointObserver.isMatched(Breakpoints.Handset);
  }

  toggleInterest() {

    const dConfig = {
      hasBackdrop: true,
      closeOnEsc: true,
      backdropClass: '',
      closeOnBackdropClick: false,
      hasScroll: false,
      autoFocus: false,
      viewContainerRef: undefined,
    };
    if ( this.isCarMarket) {
    const popup = this.dialog.open(UserInfoGaModalComponent,
      {
        width: this.isMobileView() ? '400px' : '450px',
        panelClass: 'custom-dialog-padding',
        data: {
          id: this.data.id
        }
      });
    popup.afterClosed().subscribe(res => {
      console.log(res);

      if (!res) {
        return;
      }
      dataLayer.push({
        event: 'button_click_interested',
        item_id: this.data.id,
        item_name: this.data.Manufacturer + ' ' + this.data.Model,
        item_price: this.data.CarPrice,
        item_year: this.data.ManufactureDate,
        user_id: sessionStorage.getItem('user-id'),
        userId: sessionStorage.getItem('user-id'),
      });

      const dialogConfig = {
        hasBackdrop: true,
        closeOnEsc: true,
        backdropClass: '',
        closeOnBackdropClick: false,
        hasScroll: false,
        autoFocus: false,
        viewContainerRef: undefined,
      };
      this.carService.updateUAEInterest(this.data.id, 'Interested', this.importType).subscribe((res1: any) => {
        console.log(res1);
      });
      const thankYouDlg = this.dialogService.open(ThankYouGaDialogComponent, dialogConfig);

      thankYouDlg.onClose.subscribe((result: any) => {
        this.nbDialogRef.close(this.data);
      });
    });
  } else {
    dataLayer.push({
      event: 'button_click_interested',
      item_id: this.data.id,
      item_name: this.data.Manufacturer + ' ' + this.data.Model,
      item_price: this.data.CarPrice,
      item_year: this.data.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });

    const dialogConfig = {
      hasBackdrop: true,
      closeOnEsc: true,
      backdropClass: '',
      closeOnBackdropClick: false,
      hasScroll: false,
      autoFocus: false,
      viewContainerRef: undefined,
    };
    this.carService.updateUAEInterest(this.data.id, 'Interested', this.importType).subscribe((res: any) => {
      console.log(res);
    });
    const thankYouDlg = this.dialogService.open(ThankYouGaDialogComponent, dialogConfig);

    thankYouDlg.onClose.subscribe((result: any) => {
      this.nbDialogRef.close(this.data);
    });
  }
  }


  toggleMoreInfo(car: any) {

    const isMobile = this.isMobileView();

    dataLayer.push({
      event: 'button_click_more_info_list',
      item_id: car.id,
      item_name: car.Manufacturer + ' ' + car.Model,
      item_price: car.CarPrice,
      item_year: car.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });

    const dialogConfig: NbDialogConfig<any> = {
      hasBackdrop: true,
      closeOnEsc: true,
      backdropClass: '',
      dialogClass: isMobile ? 'full-screen-dialog' : '',
      closeOnBackdropClick: false,
      hasScroll: false,
      autoFocus: false,
      viewContainerRef: undefined,
      context: {
        data: car ?? {},
        source: this.source,
        // currencies: this.currencies,
        isLoadingCalc: this.isLoading,
        vehicleValue: this.vehicleValue
      }
    };

    console.log(this.source);
    // this.calculate(car);

    // const self = this;
    // const loadingSubscription = this.isLoading.subscribe(isLoading => {
    //   if (!isLoading) {
    //     this.vehicleValue.next(self.calculate(car) || {});
    //   }
    // });

    const dialogRef = this.dialogService.open(MyCarModalComponent, dialogConfig);

    if (isMobile) {
      dialogRef.componentRef.instance.nbDialogRef = dialogRef; // Set the dialogRef in the component
    }

    // this.carsService.updateInterest(car.id, 'RequestedMoreInfo','Commercial').subscribe((res: any) => {
    //   console.log(res);
    // });

    dialogRef.onClose.subscribe((result: any) => {
      // Action to be performed when the dialog closes
      console.log('Dialog closed', result);
      if (result?.code === 200) {
        // this.refreshCars();
        // this.cars$.subscribe(
        //     (res: any) => {
        //         this.carsList = res;
        //         console.log(this.carsList);
        //     }
        // );
      }
      // loadingSubscription.unsubscribe();
      // this.vehicleValue.next(null);
    });

  }

  addToBasket(data: any): void {
    dataLayer.push({
      event: 'button_click_basket',
      item_id: this.data.id,
      item_name: this.data.Manufacturer + ' ' + this.data.Model,
      item_price: this.data.CarPrice,
      item_year: this.data.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });

    this.carService.addToMyList(data.id).pipe(map((res: any) => {
      if (res.code === 200) {
        this.messageService.add({severity: 'success', summary: 'הוספת רכב לרשימה שלי', detail: 'הרכב נוסף בהצלחה'});
      } else {
        this.messageService.add({severity: 'danger', summary: 'הוספת רכב לרשימה שלי', detail: 'אירעה תקלה בהוספת רכב.'});

      }
    })).subscribe();

  }

  formatDate(date: string): string {
    if (!date) {
      return '';
    }
    return moment.utc(date).format('DD-MM-YYYY');
  }
  getFormattedDate(date: string): string {
    if (date === '') {
      return '';
    }
    const isoDate = new Date(date).toISOString();
    return isoDate.split('T')[0];
  }

  getWeightText(): string {
    let weight = this.carForm.get('TotalWeight').value;
    switch (weight) {
      case 1:
        return 'עד 3,500 ק"ג';
      case 2:
        return '4,500 ק"ג -3,500 ק"ג';
      case 3:
        return 'מעל ל 4,500 ק"ג';
      default:
        return ''; // or some default text
    }
  }

  protected readonly faLock = faLock;
  protected readonly round = round;
}
